export default {
  SHOW_DESCRIPTION_MODAL: 'SHOW_DESCRIPTION_MODAL',
  CLOSE_DESCRIPTION_MODAL: 'CLOSE_DESCRIPTION_MODAL',
  SHOW_GAME_MODAL: 'SHOW_GAME_MODAL',
  CLOSE_GAME_MODAL: 'CLOSE_GAME_MODAL',
  SHOW_NOTIFICATION_MODAL: 'SHOW_NOTIFICATION_MODAL',
  CLOSE_NOTIFICATION_MODAL: 'CLOSE_NOTIFICATION_MODAL',
  SET_MODAL_NOTIFICATION: 'SET_MODAL_NOTIFICATION',
};
